// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24XFF","left":"styles_left__1tSNV","desktopActions":"styles_desktopActions__1GpfA","title":"styles_title__1T-sw"};